import { render, staticRenderFns } from "./CardOffice.vue?vue&type=template&id=a1b1e710"
import script from "./CardOffice.vue?vue&type=script&lang=js"
export * from "./CardOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports